/**
 * Current Household Hook
 *
 * Fetches the current user's household with details including
 * net_worth_sharing_enabled. Separate from useAuth() which only
 * provides minimal household info (id, name).
 */

import { useQuery } from '@tanstack/react-query';
import { fetchApi } from '@/shared/services';
import type { HouseholdWithMembers } from '@/shared/types';

export const householdKeys = {
  current: ['household', 'current'] as const,
};

export function useCurrentHousehold() {
  return useQuery({
    queryKey: householdKeys.current,
    queryFn: () => fetchApi<HouseholdWithMembers>('/households/current'),
    staleTime: 1000 * 60 * 5,
  });
}
